export default () => {
    // HTML шаблон спиннера
    const $spinnerTemplate = $('<div class="hh-spinner-v2">\n' +
        '                <div class="hh-spinner-v2__container">\n' +
        '                    <div class="hh-spinner-v2__bounce"></div>\n' +
        '                    <div class="hh-spinner-v2__bounce"></div>\n' +
        '                    <div class="hh-spinner-v2__bounce"></div>\n' +
        '                </div>\n' +
        '            </div>');

    $(document).ready(function() {

        // Проходим по всем элементам Contact Form 7 и вставляем спиннер
        const cforms = document.querySelectorAll('.wpcf7 > form');

        cforms.forEach(form => {
            // Вставляем наш спиннер
            const $button = $(form).find('button, input[type="submit"]').first();

            if ($button.length) {

                // Вставляем шаблон
                $button.after($spinnerTemplate);
            }

            form.addEventListener('submit', function (event) {
                const spinner = $(this).find('.hh-spinner-v2').first();
                const button = $(this).find('button, input[type="submit"]').first();

                spinner.show();
                button.css('visibility', 'hidden');

            });

            // Убираем спиннер и показываем кнопку после попытки отправки
            $(form).on('wpcf7submit wpcf7mailfailed wpcf7invalid wpcf7mailsent', function() {
                const $spinner = $(this).find('.hh-spinner-v2').first();
                const $button = $(form).find('button, input[type="submit"]').first();

                $button.css('visibility', 'visible');
                $spinner.hide();
            });
        });
    });

}